// extracted by mini-css-extract-plugin
export default {"page":"AdminLogin_page__avdV6","form_container":"AdminLogin_form_container__AHnQG","logo":"AdminLogin_logo__35VWa"};